// Забравена парола: телефон + имейл (двете трябва да съвпаднат с акаунта)
// → код по SMS → нова парола. Най-много 2 кода на 12 часа.

import React, { useState } from 'react';
import { KeyboardAvoidingView, Platform, ScrollView, View } from 'react-native';
import { api } from '../api';
import { showError, showSuccess } from '../toast';
import { MapBackground } from '../map-background';
import { Button, Card, Constrain, Input, Label, Muted, Title } from '../ui';
import { t } from '../i18n';

export default function ForgotPasswordScreen({ navigation }: any) {
  const [step, setStep] = useState<'identify' | 'reset'>('identify');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const requestCode = async () => {
    setLoading(true);
    try {
      await api('/auth/forgot-password', { body: { phone, email: email.trim() } });
      showSuccess(t('Изпратихме код по SMS.'));
      setStep('reset');
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const reset = async () => {
    setLoading(true);
    try {
      await api('/auth/reset-password', { body: { phone, code, newPassword } });
      showSuccess(t('Паролата е сменена. Влезте с новата.'));
      navigation.goBack();
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <KeyboardAvoidingView style={{ flex: 1 }} behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
      <MapBackground />
      <ScrollView contentContainerStyle={{ padding: 16, paddingBottom: 140 }} keyboardShouldPersistTaps="handled">
        <Constrain>
          <View style={{ marginTop: 90, maxWidth: 440, width: '100%', alignSelf: 'center' }}>
            <Title>{t('Забравена парола')}</Title>

            {step === 'identify' ? (
              <Card>
                <Muted>
                  {t('Въведете телефона и имейла от профила си — двете трябва да съвпадат, за да изпратим код. Възможно е най-много 2 пъти на 12 часа.')}
                </Muted>
                <Label>{t('Телефон')}</Label>
                <Input value={phone} onChangeText={setPhone} keyboardType="phone-pad" placeholder="+359 88 …" />
                <Label>{t('Имейл')}</Label>
                <Input
                  value={email}
                  onChangeText={setEmail}
                  autoCapitalize="none"
                  keyboardType="email-address"
                  placeholder="ime@poshta.bg"
                />
                <Button
                  title={t('Изпрати код по SMS')}
                  onPress={requestCode}
                  disabled={phone.trim().length < 6 || !email.includes('@')}
                  loading={loading}
                  style={{ alignSelf: 'stretch' }}
                />
                <Button title={t('Назад към входа')} variant="ghost" onPress={() => navigation.goBack()} />
              </Card>
            ) : (
              <Card>
                <Muted>{t('Изпратихме 6-цифрен код на {phone}. Въведете го и изберете нова парола.', { phone })}</Muted>
                <Label>{t('SMS код')}</Label>
                <Input value={code} onChangeText={setCode} keyboardType="number-pad" maxLength={6} placeholder="123456" autoFocus />
                <Label>{t('Нова парола (мин. 8 знака)')}</Label>
                <Input value={newPassword} onChangeText={setNewPassword} secureTextEntry placeholder="••••••••" />
                <Muted>{t('Смяната прекратява всички активни сесии — влизате наново само вие.')}</Muted>
                <Button
                  title={t('Смени паролата')}
                  onPress={reset}
                  disabled={code.length !== 6 || newPassword.length < 8}
                  loading={loading}
                  style={{ alignSelf: 'stretch' }}
                />
              </Card>
            )}
          </View>
        </Constrain>
      </ScrollView>
    </KeyboardAvoidingView>
  );
}
